import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import styles from './styles.module.scss';
import { RadioInput } from 'components/form';
import { BaseEditModal } from 'components/edit-modals';

interface QuestionCategory {
  questions: string[];
  recommended: string;
}

interface QuestionsData {
  question1: QuestionCategory;
  question2: QuestionCategory;
  question3: QuestionCategory;
  question4: QuestionCategory;
  question5: QuestionCategory;
}

interface QuestionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (selectedQuestion: string) => void;
  selectedCategory: string | null;
  questionsData: QuestionsData;
}

const QuestionModal: React.FC<QuestionModalProps> = ({
  isOpen,
  onClose,
  onSave,
  selectedCategory,
  questionsData
}) => {
  const currentQuestions = selectedCategory
    ? questionsData[selectedCategory as keyof QuestionsData]?.questions || []
    : [];

  const schema = yup.object().shape({
    questionType: yup.string().required('Please select a question'),
  });

  const { register, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      questionType: questionsData[selectedCategory as keyof QuestionsData]?.recommended || '',
    },
  });

  const onSubmit = (data: { questionType: string }) => {
    if (data.questionType) {
      onSave(data.questionType);
      onClose();
    }
  };

  return (
    <BaseEditModal
      isOpen={isOpen}
      onClose={onClose}
      title="Technical Skill"
      onSubmit={handleSubmit(onSubmit)}
    >
      <div className={styles.formSection}>
        <p className={`border-b border-[#D0D5DD] pb-4 ${styles.instruction}`}>
          You can select any of the question type that best resonate with you for this technical skill
        </p>
        <div className={styles.optionsContainer}>
          <RadioInput
            name="questionType"
            options={currentQuestions.map(question => ({ value: question, label: question }))}
            register={register}
            validatorMessage={errors.questionType?.message}
            parentClassName='!mb-2'
            type="radio"
          />
        </div>
      </div>
    </BaseEditModal>
  );
};

export default QuestionModal;